<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83576 5.83576V4.1684C5.83576 3.24754 6.58227 2.50104 7.50313 2.50104H15.8399C16.7608 2.50104 17.5073 3.24754 17.5073 4.1684V15.8399C17.5073 16.7608 16.7608 17.5073 15.8399 17.5073H7.50313C6.58227 17.5073 5.83576 16.7608 5.83576 15.8399V14.1726"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="3.33472"
      y="5.83576"
      width="8.33681"
      height="8.33681"
      rx="2"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.5073 7.56982H11.6715"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.5073 12.5052H11.6715"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.6715 2.50104V17.5073"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.8095 11.4631L6.30846 8.54523"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.30846 11.4631L8.8095 8.54523"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number | string
  }>(),
  {
    size: 20,
  },
)
</script>
